import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';
import { environment } from 'projects/desktop/src/environments/environment';
import { Observable } from 'rxjs';
import { map, skip } from 'rxjs/operators';
import { User } from './user';

@Injectable()
export class CanUserActivateRouteGuard implements CanActivate {
    protected currentUser: User

    constructor(
        private router: Router,
        protected appStateQuery: AppStateQuery
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.appStateQuery.currentUser$.pipe(
            skip(this.appStateQuery.getValue().authorized ? 0 : 1),
            map(currentUser => {
                const allowedRolesPath = route.data.allowedRolesPath
                let allowedRoles

                this.appStateQuery.rolesAccessMap$.subscribe(rolesMap => {
                    allowedRoles = rolesMap.get(allowedRolesPath)
                })

                // if (environment.dev) {
                // 	return true;
                // }

                return currentUser && (allowedRoles.includes('*') || currentUser.roles.map(role => role.name).find(roleName => allowedRoles.includes(roleName)) ? true : this.router.parseUrl('/home'))

            })
        )
    }
}
